const ASSET_CLASS_NAMES = require('../../constants');
const { falcorPortfolioId } = require('../../utils');
const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');
const { groupBy, values, findIndex } = require('lodash');
const defaultNotificationApi = require('../notifications/api-factory');
const defaultNotificationService = require('../notifications/service-factory');
const config = require('../../config'); const apiConfig = require('../../api-config');
const pathResult = require('../path-result');
const RESOURCE_TYPE = 'WM_EBANK';

function parseUserEntitlement(userEntitlement, resourceId) {
  const entitlement = userEntitlement.resourceActionModel || [];

  let resourceEntitlement = entitlement
    .find((resource) => (
      resource.resourceName.type === RESOURCE_TYPE &&
      (resource.resourceName.id.toLowerCase() === resourceId.toLowerCase() ||
      (resource.resourceName.id.toLowerCase() === 'dashboard' &&
        resourceId.toLowerCase() === 'portfolio'))
    ));

  if(resourceId.toLowerCase() == 'insight'){
    resourceEntitlement = entitlement
      .find((resource) => (
        resource.resourceName.type === RESOURCE_TYPE &&
        (resource.resourceName.id.toLowerCase().includes('insight') )
      ));
  }

  if (!resourceEntitlement) {
    return false;
  }

  return true;
}

function parseTermsRmia(data){
  if((!data) || data.length==0){
        return null;
    }
    else {
      return data;
    }
}

function parseGetCurrency(item) {
  let currency = null;
  if (item && item.length > 0) currency = item[0].prefRefCcy;

  return {
    currency,
  };
}

function parseCcyDiscoveryTermsRmia(data){
   const currency = parseGetCurrency(data[1]);
   return {
      currency,
      discoveryStatus : data[0].discoveryStatus,
      termsConditions : parseTermsRmia(data[2]),
      rmiaDetails : parseTermsRmia(data[3])
   };
}

function parseRetrievedUserPreference(data) {
  if (data && data.edelPref != null) {
    return JSON.stringify({
      edelPref: data.edelPref
    });
  } else {
    return JSON.stringify({
      edelPref: 0
    });
  }
}


function parseEntitlementList(userEntitlement){
  const entitlementList = userEntitlement.resourceActionModel || [];
  const modules = userEntitlement.modules || [];
  let returnEntitlementList = {};
  let returnModules = [];
 
  entitlementList.map(function(item) {

    returnEntitlementList[item.resourceName.id.toLowerCase()] = true;
  
  });
  modules.map(function(item) {
    returnModules.push(item.toLowerCase()); 
  });

  returnEntitlementList.roles = userEntitlement.roles;
  return { entitlementList : returnEntitlementList, modules : returnModules }
}

function parseUserInsightRoles(userEntitlement){

  const entitlementList = userEntitlement.resourceActionModel || [];
  var insightsRole = [];


  entitlementList.map(function(item) {

    var roleID = item.resourceName.id.toLowerCase();
    var hasInsight =  roleID.indexOf("insight") !== -1;

    if(hasInsight){
      insightsRole.push(item.resourceName.id);
    }
  
  });
  return insightsRole.toString();

}

function parseUserPortfolioRelation(portfolio, isPaymentTrue) {

  return {
    id: portfolio.pfId !== null?falcorPortfolioId(portfolio.pfId): portfolio.relId,
    title: portfolio.pfId !== null? portfolio.pfId: portfolio.relId,
    referenceCurrency: portfolio.refCcy,
    branchCode: portfolio.branchCode,
    relId: portfolio.relId,
    relIdType: portfolio.relIdType,
    pfType: portfolio.pfType,
    //isPaymentAvailable: portfolio.module != null || portfolio.module != undefined ? portfolio.module.indexOf("P3") != -1 : false
    isPaymentAvailable: isPaymentTrue,
    isEDeliveryAvailable: portfolio.module != null && portfolio.module != undefined ? portfolio.module.indexOf("P6") != -1 : false,
    isDownloadAvailable: portfolio.module != null && portfolio.module != undefined ? portfolio.module.indexOf("P2") != -1 : false,
    isTradingAvailable: portfolio.module != null && portfolio.module != undefined ? portfolio.module.indexOf("P4") != -1 : false,
    relIdName: portfolio.relIdName
  };
}

function parseData(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseOverallMarketValue(overallMarketValue) {
  if (!overallMarketValue) return null;

  return {
    price: {
      value: overallMarketValue.mktValue,
    },
    dayChange: {
      value: overallMarketValue.mktDayChg,
      percent: overallMarketValue.mktDayChgPct,
    },
    asOfDate: {
      value: overallMarketValue.asOfDate,
    },
    netIncome: {
      value: overallMarketValue.netIncomeYtd,
    },
  };
}

function parseServerTimeEntitlementEdelPortfolio([authTime, entitlement, edelivery, portfolio]) {

    if(apiConfig.branchCode === 4){
      portfolio = edelivery;
      edelivery = null;
    }
    const result = portfolio.portfoliosWithAccess != undefined ? portfolio.portfoliosWithAccess : portfolio;
    const isPaymentTrue = result.some(x => x.module != undefined && x.module != null ? x.module.indexOf("P3") != -1 : false);
    const portfolios = result.map((e, i, arr) => parseUserPortfolioRelation(e, isPaymentTrue));
    const entitlementData = parseEntitlementList(entitlement);

    return{
      serverAuthTime : authTime,
      insightRead : parseUserEntitlement(entitlement, 'insight'),
      entitlementList: entitlementData.entitlementList,
      entitlementModule: entitlementData.modules,
      userPrefEdelivery : parseRetrievedUserPreference(edelivery),
      insightsRoles: parseUserInsightRoles(entitlement),
      portfolioLength : portfolios.length,
      portfolioTop : !portfolios[0] ? null : portfolios[0],
    };
  }

function parsePortfoliosDataArray(arr){
    
    const overallMarketVal = arr[0];
    const marketVal = arr[1];
    const currencyExposure = arr[2];
    const assetNames = arr[3];
    const chartData = arr[4];
    const lineChartData = arr[5];

    return{
        overallMarketValuePrice : overallMarketVal.price.value,
        overallMarketValueAsOfDate : overallMarketVal.asOfDate.value,
        overallMarketValueDayChangeVal : overallMarketVal.dayChange.value,
        overallMarketValueDayChangePercent : overallMarketVal.dayChange.percent,
        overallMarketValueNetIncome : overallMarketVal.netIncome.value,
        marketVal : marketVal,
        marketValueLength : marketVal.length,
        currencyExposure : currencyExposure,
        assetNames : assetNames,
        performanceChart : chartData,
        performanceLineChart : lineChartData,
        assetList : arr[6],

    };
}

function parseMarketValue(marketValue) {
  return {
    date: `${marketValue.asOfDate}T00:00:00.000Z`,
    price: {
      value: marketValue.mktValue,
    },
  };
}

function parseAssetMarketValue(asset) {
    // assetShortDesc field is present for CH to handle Flexible asset class
  return {
    class: asset.assetShortDesc ? asset.assetShortDesc : ASSET_CLASS_NAMES[asset.assetCls],
    name: asset.assetDesc,
    allocation: asset.assetPct,
    marketValue: {
      value: asset.mktValue,
    },
    dayChange: {
      value: asset.mktDayChg,
      percent: asset.mktDayChgPct,
    },
  };
}

function parseAssetName(asset) {
    // assetShortDesc field is present for CH to handle Flexible asset class
  return {
    class: asset.assetShortDesc ? asset.assetShortDesc : ASSET_CLASS_NAMES[asset.assetCls],
    name: asset.assetDesc
  };
}

function parseLineChartData(item) {
  return {
    titleText: item.incMth,
    valueText: item.mthAggPerf,
    value: item.mthAggPerf,
    incYear: item.incYear? item.incYear: null,
  };
}

function parseBarChartData(item) {
  return {
    titleText: item.incMth,
    valueText: item.mthAggPerf,
    value: item.mthAggPerf,
    incYear:  item.incYear? item.incYear: null
  };
}

function parseCollateralSurplus(collateralSurplus) {
  return JSON.stringify(collateralSurplus);
}

function parseCurrencyExposure(currencyExposure) {
  return {
    portfolioId: currencyExposure.pfId,
    portfolioTotal: currencyExposure.portTotal,
    portfolioCurrency:currencyExposure.portCcy,
    destinationCurrency: currencyExposure.destinationCurrency,
    currencyAllocation: map(parseCurrencyAllocation, currencyExposure.ccyAlloc)
  }
}

function parseCurrencyAllocation(item) {
  return {
    currency: item.ccy,
    currencyAmount: item.ccyAmt,
    currencyAmtDestCcy: item.ccyAmtDestCcy,
    currencyPercentage: item.ccyAmtPct,
    currencyTRDAmount: item.trdCcyAmt
  }
}

function parsePortfoliosAndStatusData( data ){
  if ((!data) || data.length == 0) {
    return null;
  } else {
  return JSON.stringify(data);
  }
}

function serviceFactory({ api, requestHandler }) {

  const notificationApi = defaultNotificationApi({
      requestHandler,
      baseUrl: `${config.baseUrl}/alertsandnotifications/${apiConfig.apiversion}/`
    });
  const notificationService = defaultNotificationService({ notificationApi });

  const getPortfolios = memoizer()((metaData) =>
    api.getUserPortfolioRelations(metaData).then( (response) => {
      const result = response.portfoliosWithAccess != undefined ? response.portfoliosWithAccess : response;
      const isPaymentTrue = result.some(x => x.module != undefined && x.module != null ? x.module.indexOf("P3") != -1 : false);
      //return map(parseUserPortfolioRelation, result);
      return result.map((e, i, arr) => parseUserPortfolioRelation(e, isPaymentTrue));
    }));

  const getInActivePortfolio = memoizer()((metaData) =>
    api.getUserPortfolioRelations(metaData).then( (response) => {
      if(!response) return [];
      if(!response.portfoliosWithoutAccess ) return [];
      return response.portfoliosWithoutAccess;
    }));

  const getOverallMarketValue = memoizer()((portfolioId, metaData) =>
    api.getOverallMarketValue(portfolioId, metaData).then(parseOverallMarketValue));

  const getMarketValues = memoizer()((portfolioId, metaData) =>
    api.getPortfolioValueMovement(portfolioId, metaData).then(map(parseMarketValue)));

   const getAssetMarketValue = memoizer()((portfolioId, metaData) =>
  api.getAssetMarketValue(portfolioId, metaData).then(map(parseAssetMarketValue)));

  const getAssetNames = memoizer()((portfolioId, metaData) =>
    api.getAssetMarketValue(portfolioId, metaData).then(map(parseAssetName)));

  const portfoliosChartData = memoizer()((portfolioId, metaData) =>
    api.getPortfoliosPerfChartData(portfolioId, metaData).then((response) => {
      if(!response) return [];
      return map(parseBarChartData, response.barChartAggregate);
    }));

  const portfoliosLineChartData = memoizer()((portfolioId, metaData) =>
    api.getPortfoliosPerfChartData(portfolioId, metaData).then((response) => {
     if(!response) return [];
      return map(parseLineChartData, response.timeLineChartAggregate);
    }));

  const portfoliosYTDData = memoizer()((portfolioId, metaData) =>
    api.getPortfoliosPerfChartData(portfolioId, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response.chartYTDTWRR);
    }));

  const getCollateralSurplus = memoizer()((portfolioId, metaData) =>
    api.getCollateralSurplus(portfolioId, metaData).then(parseCollateralSurplus));

  const getCurrencyExposure = memoizer()((portfolioId, metaData) =>
    api.getCurrencyExposure(portfolioId, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(parseCurrencyExposure(response));
    }).catch((error) => {
        return null;
    })
  );

  const getDashboardData  = memoizer()((metaData) => 
    api.getServerTimeEntitlementEdelPortfolio(metaData)
                            .then((response) => {
                             if(!response) return null;
                              const serverTimeEntitlementEdelPortfolio = parseServerTimeEntitlementEdelPortfolio(response);
                              return JSON.stringify(serverTimeEntitlementEdelPortfolio);
                            })
                            .catch((error) => {
                                return null;
                            })
    );
    
    const getPortfoliosData = (portfolioId, metaData) => {
    const getOverallMarketValue = api.getOverallMarketValue(portfolioId, metaData).then(parseOverallMarketValue);
    const getPortfolioValueMovement = api.getPortfolioValueMovement(portfolioId, metaData).then(map(parseMarketValue));
    const getCurrencyExposure = api.getCurrencyExposure(portfolioId, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(parseCurrencyExposure(response));
    }).catch((error) => {
        return null;
    });
    const assetNames = api.getAssetMarketValue(portfolioId, metaData).then(map(parseAssetName));
    const portfolioChartData = api.getPortfoliosPerfChartData(portfolioId, metaData).then((response) => {
      if(!response) return [];
      return map(parseBarChartData, response.barChartAggregate);
    });
    const portfolioLineChartData = api.getPortfoliosPerfChartData(portfolioId, metaData).then((response) => {
     if(!response) return [];
      return map(parseLineChartData, response.timeLineChartAggregate);
    });
    const assetList = api.getAssetMarketValue(portfolioId, metaData).then((response => { 
      if(!response) return null;
      return response; 
    }));
    
    return Promise.all([getOverallMarketValue, getPortfolioValueMovement, getCurrencyExposure, assetNames, portfolioChartData, portfolioLineChartData, assetList])
           .then((response) => {
                if(!response) return null;
                return JSON.stringify(parsePortfoliosDataArray(response));
           })
           .catch((err) => {
                return null;
           });
  }

  const getCcyDiscoveryTermsRmia  = memoizer()((language, metaData) => 
    api.getCcyDiscoveryTermsRmia(language, metaData)
                            .then((response) => {
                             if(!response) return null;
                              const ccyDiscoveryTermsRmia = parseCcyDiscoveryTermsRmia(response);
                              return JSON.stringify(ccyDiscoveryTermsRmia);
                            })
                            .catch((error) => {
                                return null;
                            })
    );

  const portfoliosAndStatusData = ({ inputParam, metaData }) =>
    api
      .portfoliosAndStatusData(inputParam, metaData)
      .then(parsePortfoliosAndStatusData);

  const getOverallMarketValueAsOfDate = (portfolioId, metaData) =>
      api
        .getOverallMarketValue(portfolioId, metaData)
        .then(parseData);
  
  return {
    getPortfolios,
    getOverallMarketValue,
    getMarketValues,
    getAssetMarketValue,
    getAssetNames,
    getCollateralSurplus,
    portfoliosChartData,
    portfoliosLineChartData,
    getCurrencyExposure,
    portfoliosYTDData,
    getInActivePortfolio,
    getDashboardData,
    getPortfoliosData,
    getCcyDiscoveryTermsRmia,
    portfoliosAndStatusData,
    getOverallMarketValueAsOfDate
  };

}

module.exports = serviceFactory;